import { useEffect, useState } from "react";
import { AUDIO_TEST_MODE, AUDIO_TEST_RESULT_ROUTE, AudioTestCaptures } from "../services/audioTestMode";

// Selo fixo do modo teste: lembra que nada e enviado e da atalho ao resultado.
export default function AudioTestBanner() {
  const [count, setCount] = useState(() => AudioTestCaptures.list().length);

  useEffect(() => {
    const refresh = () => setCount(AudioTestCaptures.list().length);
    window.addEventListener('audio-test-captures-changed', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('audio-test-captures-changed', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  if (!AUDIO_TEST_MODE) return null;

  return (
    <a className="audio-test-banner" href={ AUDIO_TEST_RESULT_ROUTE } title="Nada e enviado ao backend. Clique para ver o JSON capturado.">
      <strong>MODO TESTE</strong>
      <span>{ count } { count === 1 ? 'chamada' : 'chamadas' } capturadas</span>
    </a>
  );
}
